import { useEffect, useLayoutEffect, useState } from 'react';

type PhoneNumberWithChangeHandler = [string, (phoneNumber: string | undefined) => void];

const useTrimmedPhoneNumber = (
  value: string,
  onChange?: (phoneNumber: string) => void,
): PhoneNumberWithChangeHandler => {
  const limitInput = (str: string) => str.slice(0, 12);

  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  useLayoutEffect(() => {
    const trimmedValue = limitInput(tempValue);

    setTempValue(trimmedValue);
    onChange?.(trimmedValue);
  }, [tempValue]);

  const handleChange = (phoneNumber: string | undefined) => {
    setTempValue(phoneNumber || '');
  };

  return [tempValue, handleChange];
};

export default useTrimmedPhoneNumber;
